/* Rabbit0-Store Theme JS v9 */

/* ========== HERO SLIDESHOW ========== */
var r0HeroTimer;
function r0InitHero(){
  try {
    var slides = document.querySelectorAll('.r0-hero-slide');
    var dots = document.querySelectorAll('.r0-hero-dot');
    if(slides.length < 2) return;
    var idx = 0;
    function show(n){
      slides.forEach(function(s){ s.classList.remove('active'); });
      dots.forEach(function(d){ d.classList.remove('active'); });
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('active');
      if(dots[idx]) dots[idx].classList.add('active');
    }
    window.r0HeroGo = function(n){
      show(n);
      clearInterval(r0HeroTimer);
      r0HeroTimer = setInterval(function(){ show(idx+1); }, 5000);
    };
    r0HeroTimer = setInterval(function(){ show(idx+1); }, 5000);
    var prev = document.querySelector('.r0-hero-nav.prev');
    var next = document.querySelector('.r0-hero-nav.next');
    if(prev) prev.onclick = function(){ r0HeroGo(idx-1); };
    if(next) next.onclick = function(){ r0HeroGo(idx+1); };
  } catch(e){ console.error('Hero:', e); }
}

/* ========== CAROUSEL ARROWS ========== */
function r0CarScroll(btn, dir){
  try {
    var wrap = btn.closest('.r0-carousel-wrap');
    var scroller = wrap.querySelector('.r0-prod-scroll, .r0-rank-scroll');
    if(!scroller) return;
    var card = scroller.querySelector('.r0-p-card, .r0-rank-card');
    var step = card ? (card.offsetWidth + 12) * 2 : 400;
    scroller.scrollBy({ left: step * dir, behavior: 'smooth' });
  } catch(e){ console.error('Carousel:', e); }
}

/* ========== RANKING TABS ========== */
function r0RankSwitch(tab){
  try {
    tab.parentElement.querySelectorAll('.r0-rank-tab').forEach(function(t){ t.classList.remove('on'); });
    tab.classList.add('on');
    var id = tab.getAttribute('data-rank-target');
    document.querySelectorAll('.r0-rank-panel').forEach(function(p){ p.classList.add('r0-hidden'); });
    var target = document.getElementById(id);
    if(target) target.classList.remove('r0-hidden');
  } catch(e){ console.error('Rank:', e); }
}

/* ========== VIEW TOGGLE ========== */
function r0InitViewToggle(){
  try {
    var btns = document.querySelectorAll('.r0-v-btn');
    if(!btns.length) return;
    btns.forEach(function(btn){
      btn.onclick = function(){
        btns.forEach(function(b){ b.classList.remove('on'); });
        btn.classList.add('on');
        var lv = document.getElementById('r0-list-view');
        var gv = document.getElementById('r0-grid-view');
        if(btn.getAttribute('data-view') === 'grid'){
          if(lv) lv.style.display = 'none';
          if(gv) gv.style.display = '';
        } else {
          if(lv) lv.style.display = '';
          if(gv) gv.style.display = 'none';
        }
      };
    });
  } catch(e){ console.error('View:', e); }
}

/* ========== FILTER PANEL ========== */
function r0ToggleFilter(){
  try {
    var p = document.getElementById('r0-filter-panel');
    var o = document.getElementById('r0-overlay');
    if(!p) return;
    var isOpen = p.classList.toggle('open');
    if(o) o.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  } catch(e){ console.error('Filter:', e); }
}

function r0InitFilter(){
  try {
    var o = document.getElementById('r0-overlay');
    if(o) o.onclick = function(){ r0ToggleFilter(); };
  } catch(e){ console.error('FilterOv:', e); }
}

/* ========== SEARCH (Header Overlay) ========== */
function r0OpenSearch(){
  try {
    var overlay = document.getElementById('r0-search-overlay');
    if(!overlay){ window.location.href = '/search'; return; }
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    var input = document.getElementById('r0-hdr-search');
    if(input){
      input.value = '';
      setTimeout(function(){ input.focus(); }, 150);
    }
    var box = document.getElementById('r0-search-results');
    if(box){
      box.innerHTML =
        '<div class="r0-sr-section">人気の検索</div>' +
        '<a href="/search?q=%E3%83%A9%E3%83%94%E3%83%83%E3%83%89%E3%83%88%E3%83%AA%E3%82%AC%E3%83%BC&type=product" class="r0-sr-item"><div class="r0-sr-info"><div class="r0-sr-title">ラピッドトリガー</div></div></a>' +
        '<a href="/search?q=%E3%83%9E%E3%82%A6%E3%82%B9&type=product" class="r0-sr-item"><div class="r0-sr-info"><div class="r0-sr-title">マウス</div></div></a>' +
        '<a href="/search?q=%E3%83%9E%E3%82%A6%E3%82%B9%E3%83%91%E3%83%83%E3%83%89&type=product" class="r0-sr-item"><div class="r0-sr-info"><div class="r0-sr-title">マウスパッド</div></div></a>';
    }
  } catch(e){ console.error('SearchOpen:', e); }
}

function r0CloseSearch(){
  try {
    var overlay = document.getElementById('r0-search-overlay');
    if(overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  } catch(e){ console.error('SearchClose:', e); }
}

function r0InitSearch(){
  try {
    var overlay = document.getElementById('r0-search-overlay');
    var input = document.getElementById('r0-hdr-search');
    var form = document.getElementById('r0-search-form');
    if(!overlay || !input) return;

    overlay.onclick = function(e){ if(e.target === overlay) r0CloseSearch(); };
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && overlay.classList.contains('open')) r0CloseSearch();
    });

    if(form){
      form.onsubmit = function(e){
        e.preventDefault();
        var q = input.value.trim();
        if(q){
          r0CloseSearch();
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      };
    }

    var timer;
    input.oninput = function(){
      clearTimeout(timer);
      var q = input.value.trim();
      if(q.length < 1){ r0OpenSearch(); return; }
      timer = setTimeout(function(){ r0DoSearch(q); }, 300);
    };
  } catch(e){ console.error('SearchInit:', e); }
}

function r0DoSearch(q){
  var box = document.getElementById('r0-search-results');
  if(!box) return;
  box.innerHTML = '<div style="padding:20px;text-align:center;color:#999;font-size:13px">検索中...</div>';

  /* Fetch actual search page HTML and parse .r0-p-card elements */
  fetch('/search?q=' + encodeURIComponent(q) + '&type=product')
    .then(function(r){ return r.text(); })
    .then(function(html){
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var cards = doc.querySelectorAll('.r0-p-card');
      var products = [];

      cards.forEach(function(card){
        if(products.length >= 20) return;
        var href = card.getAttribute('href');
        if(!href || href.indexOf('/products/') === -1) return;
        var imgEl = card.querySelector('.r0-p-img img');
        var nameEl = card.querySelector('.r0-p-name');
        var brandEl = card.querySelector('.r0-p-brand');
        var priceEl = card.querySelector('.r0-p-price');
        var priceText = '';
        var compareText = '';
        if(priceEl){
          var clone = priceEl.cloneNode(true);
          var cmp = clone.querySelector('.r0-p-compare');
          if(cmp){ compareText = cmp.textContent.trim(); cmp.remove(); }
          var tax = clone.querySelector('.r0-tax');
          if(tax) tax.remove();
          priceText = clone.textContent.trim();
        }
        products.push({
          url: href,
          title: nameEl ? nameEl.textContent.trim() : '',
          brand: brandEl ? brandEl.textContent.trim() : '',
          image: imgEl ? (imgEl.getAttribute('src') || '') : '',
          price: priceText,
          compare: compareText
        });
      });

      if(products.length > 0){
        var h = '<div class="r0-sr-section">商品 (' + products.length + '件)</div>';
        products.forEach(function(p){
          var img = p.image ? '<img class="r0-sr-img" src="' + p.image + '" alt="">' : '<div class="r0-sr-img"></div>';
          var sub = '';
          if(p.brand) sub = '<div class="r0-sr-type">' + p.brand + '</div>';
          if(p.price) sub += '<div class="r0-sr-price">' + p.price + (p.compare ? '<span class="r0-sr-compare">' + p.compare + '</span>' : '') + '</div>';
          h += '<a href="' + p.url + '" class="r0-sr-item">' + img + '<div class="r0-sr-info"><div class="r0-sr-title">' + p.title + '</div>' + sub + '</div></a>';
        });
        h += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="r0-sr-all">すべての結果を見る →</a>';
        box.innerHTML = h;
      } else {
        box.innerHTML =
          '<div style="padding:24px 20px;text-align:center;color:#999;font-size:13px">「' + q + '」の検索結果はありません</div>' +
          '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="r0-sr-all">検索ページで確認 →</a>';
      }
    })
    .catch(function(){
      box.innerHTML = '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="r0-sr-all" style="border-top:none;padding:24px 20px">「' + q + '」で検索する →</a>';
    });
}

/* ========== INIT ========== */
document.addEventListener('DOMContentLoaded', function(){
  r0InitHero();
  r0InitViewToggle();
  r0InitFilter();
  r0InitSearch();
});
